import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { coCreate, nextActions } from '../../../data/snak3';
interface CoCreateScreenProps {
  onRestart: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function CoCreateScreen({
  onRestart
}: CoCreateScreenProps) {
  return <div className="flex flex-1 flex-col" data-id="element-377" data-mp="1btvm0g78c24n">
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="text-[9.5px] font-semibold uppercase tracking-micro text-ozGreen" data-id="element-378" data-mp="1ziojwi7ewk1w">
        {coCreate.eyebrow}
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.06,
      ease: EASE
    }} className="mt-3 font-display text-[28px] font-bold uppercase leading-[0.98] tracking-tight text-paper" data-id="element-379" data-mp="1pk8tkhg7letg">
        {coCreate.headline[0]}
        <span className="mt-0.5 block text-ozGreen" data-id="element-380" data-mp="j2bywl7ii3xd">{coCreate.headline[1]}</span>
      </motion.h2>

      <p className="mt-4 text-[12.5px] leading-relaxed text-paper/70" data-id="element-381" data-mp="sdot169955nf">{coCreate.copy}</p>

      <ol className="mt-4 flex flex-col gap-1" data-id="element-382" data-mp="nec6ynq7g2lw">
        {coCreate.arc.map((item, i) => <motion.li key={item} initial={{
        opacity: 0,
        x: -4
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.22,
        delay: 0.12 + i * 0.05,
        ease: EASE
      }} className="flex items-center gap-2 text-[11px] text-paper/55" data-id="element-383" data-mp="11dk5rfigh8pk" data-mpi={i}>
            <span className="h-1 w-1 shrink-0 rounded-full bg-ozGreen" aria-hidden="true" data-id="element-384" data-mp="16b3j8d7bxhgg" />
            {item}
          </motion.li>)}
      </ol>

      <ul className="mt-5 flex flex-col gap-1.5" data-id="element-385" data-mp="1g0n57rqc9rfj">
        {nextActions.map((action, i) => <motion.li key={action.label} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.24,
        delay: 0.24 + i * 0.06,
        ease: EASE
      }} data-id="element-386" data-mp="1u0eoa6vppy0e" data-mpi={i}>
            <a href="#next" className={`flex items-center gap-3 rounded-xl px-4 py-3 transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ozGreen focus-visible:ring-offset-2 focus-visible:ring-offset-ozNavy ${action.primary ? 'bg-ozGreen' : 'border border-paper/20'}`} data-id="element-387" data-mp="mpqcvdehg3ng">
              <span className="min-w-0 flex-1" data-id="element-388" data-mp="15e52pxd2dbmo">
                <span className={`block text-[12.5px] font-semibold leading-snug ${action.primary ? 'text-ozNavy' : 'text-paper'}`} data-id="element-389" data-mp="1adzv65chm99u">
                  {action.label}
                </span>
                <span className={`mt-0.5 block text-[10.5px] leading-snug ${action.primary ? 'text-ozNavy/75' : 'text-paper/55'}`} data-id="element-390" data-mp="1je67hnwg937f">
                  {action.detail}
                </span>
              </span>
              <ArrowRightIcon className={`h-4 w-4 shrink-0 ${action.primary ? 'text-ozNavy' : 'text-ozGreen'}`} aria-hidden="true" data-id="element-391" data-mp="3dnbnfesthb8t" />
            </a>
          </motion.li>)}
      </ul>

      <div className="mt-auto pt-5" data-id="element-392" data-mp="33udz2s158s2a">
        <p className="border-l-[3px] border-ozGreen pl-3.5 font-display text-[16px] leading-snug text-paper" data-id="element-393" data-mp="2yy5mnmebzcyt">
          {coCreate.closing}
        </p>
        <button type="button" onClick={onRestart} className="mx-auto mt-3 block h-9 rounded-full px-4 text-[12px] text-paper/60 transition-colors duration-150 hover:text-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-ozGreen" data-id="element-394" data-mp="dxfxrvb8622">
          Back to the start
        </button>
      </div>
    </div>;
}